const originalFetch = window.fetch;

window.fetch = async (input, init) => {
  console.log("Hit global fetch interceptor");
  try {
    const response = await originalFetch(input, init);

    if (response.status === 401) {
      console.log("Unauthorized access - redirecting to login page");
      window.location.href = "/";
      sessionStorage.clear();
      return;
    }

    return response;
  } catch (error) {
    console.error("Fetch error:", error);
    throw error;
  }
};
